/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import parse from 'html-react-parser';
import {blockToXmlSanitized} from "../../../utils";
import { removeSelfClosingTags } from "./toolboxXmlHelpers";

// NOSONAR: `category`/`label`/`button` are Blockly toolbox-XML pseudo-elements
// (rendered via react-blockly-toolbox, then serialized to Blockly's toolbox
// XML), not real DOM/React elements, so `iconclass`, `expandedclass`, `text`,
// `callbackKey`, and `web-class` are valid Blockly toolbox attributes rather
// than unknown props. See the same pattern in Toolbox.js, Search/index.js,
// JSBlocks/index.js, and MyBlocks/MyBlockSearch.js.
const MyBlocks = function ({ libraries }) {
    if (_.isEmpty(libraries)) {
        return (
            <category name='My Libraries' id='text' iconclass='category with-icon-paths snap-icon-file'> {/* NOSONAR */}
                <label text="No saved blocks yet"></label> {/* NOSONAR */}
            </category>
        );
    }

    for (const library of libraries) {
        library.parsedBlocks = _.values(library.blocks).map(block => {
            if (block.xml) {
                const parsedBlock = Blockly.Xml.textToDom(block.xml);
                const sanitizedBlock = blockToXmlSanitized(parsedBlock);
                let xmlText = "";
                if (sanitizedBlock.getElementsByTagName("variables").length > 0) {
                    let blockXml = sanitizedBlock.getElementsByTagName("variables")[0];
                    xmlText += Blockly.Xml.domToText(blockXml);
                }
                if (sanitizedBlock.getElementsByTagName("block").length > 0) {
                    let blockXml = sanitizedBlock.getElementsByTagName("block")[0];
                    blockXml.firstChild.setAttribute('code', block.code);
                    xmlText += Blockly.Xml.domToText(blockXml);
                }
                return { blockKey: block.name, xml: xmlText };
            }
            return { blockKey: block.name, xml: null };
        });
    }

    return (
        <category name='My Libraries' id='text' iconclass='category with-icon-paths snap-icon-file' expandedclass='category with-icon-paths snap-icon-file'> {/* NOSONAR */}
            {
                libraries.map((library) =>
                    <category name={library.name} iconclass={"inner-category " + library.name} key={library.id}> {/* NOSONAR */}
                        <button text="Delete Library" id={library.id} callbackKey="showDeleteLibraryDialog" /> {/* NOSONAR */}
                        <label text={library.name} web-class={library.hasExcludedBlocks ? 'has-warning' : ''} /> {/* NOSONAR */}
                        {
                            library.parsedBlocks.map(({ blockKey, xml }) => <React.Fragment key={blockKey}>{parse(removeSelfClosingTags(xml))}</React.Fragment>)
                        }
                    </category>
                )
            }
        </category>
    )
};

MyBlocks.propTypes = {
    libraries: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        blocks: PropTypes.object,
        parsedBlocks: PropTypes.array,
        hasExcludedBlocks: PropTypes.bool,
    })),
};

export default MyBlocks;
